import { Tooltip as AntTooltip } from 'antd';
import type { TooltipProps } from 'antd';
import clsx from 'clsx';
import styles from './index.module.scss';

function Tooltip(props: TooltipProps) {
  const { children, className, ...rest } = props;
  const tooltipContainer = clsx(styles.container, className);

  return (
    <AntTooltip className={tooltipContainer} {...rest}>
      <span>{children}</span>
    </AntTooltip>
  );
}

export default Tooltip;
